module.exports = __WEBPACK_EXTERNAL_MODULE_43__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","getDate"],"commonjs":"date-fns/get_date/index","commonjs2":"date-fns/get_date/index","amd":"date-fns/get_date/index"}
// module id = 43
// module chunks = 0